import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiFlowLabelComponent } from '../../atoms/flow-label/flow-label.component';
import { UiFlowNodeFrameComponent } from '../../atoms/flow-node-frame/flow-node-frame.component';

/** Referencia / enlace fuera de página (pentágono). */
@Component({
  selector: 'ui-flow-off-page-node',
  standalone: true,
  imports: [UiFlowNodeFrameComponent, UiFlowLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ui-flow-node-frame shape="pentagon">
      <ui-flow-label [text]="label()" tone="strong" />
    </ui-flow-node-frame>
  `,
  styles: `:host { display: inline-flex; }`,
})
export class UiFlowOffPageNodeComponent {
  readonly label = input.required<string>();
}
